function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
import { property as l } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/property.js";
import { state as h } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/state.js";
import { createRef as c } from "../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/directives/ref.js";
import { TestableLitElement as p } from "../../../utils/components/testable-lit-element/testable-lit-element.js";
var u = Object.defineProperty,
  r = function r(d, e, t, s) {
    for (var o = void 0, a = d.length - 1, n; a >= 0; a--) (n = d[a]) && (o = n(e, t, o) || o);
    return o && u(e, t, o), o;
  };
var i = /*#__PURE__*/function (_p) {
  function i() {
    var _this;
    _classCallCheck(this, i);
    _this = _callSuper(this, i, arguments), _this.options = [], _this.value = "", _this.label = "", _this.placeholder = "Search...", _this.open = !1, _this.required = !1, _this.valid = !0, _this.requiredErrorText = "Select an option from the picklist or remove the search term.", _this.displayedErrorText = "", _this._comboboxRef = c();
    return _this;
  }
  _inherits(i, _p);
  return _createClass(i, [{
    key: "selectOption",
    value: function selectOption(e) {
      var _this2 = this;
      this.open = !1, this.value = e.value, this.valid = !0, this.displayedErrorText = "", this.dispatchEvent(new CustomEvent("change", {
        detail: e,
        bubbles: !0
      })), setTimeout(function () {
        var s;
        var t = (s = _this2.shadowRoot) == null ? void 0 : s.querySelector('div[role="combobox"]');
        t == null || t.focus();
      });
    }
  }, {
    key: "setFocusClassForListItemAtIndex",
    value: function setFocusClassForListItemAtIndex(e) {
      var s, o, a, n;
      var t = (s = this.shadowRoot) == null ? void 0 : s.querySelectorAll('[role="option"]');
      (o = t[e]) == null || o.classList.add("slds-has-focus"), (n = this._comboboxRef.value) == null || n.setAttribute("aria-activedescendant", (a = t[e]) == null ? void 0 : a.id);
    }
  }, {
    key: "removeFocusClassForListItemAtIndex",
    value: function removeFocusClassForListItemAtIndex(e) {
      var s, o;
      (o = ((s = this.shadowRoot) == null ? void 0 : s.querySelectorAll('[role="option"]'))[e]) == null || o.classList.remove("slds-has-focus");
    }
  }, {
    key: "getActiveIndexOfListItems",
    value: function getActiveIndexOfListItems() {
      var s, o;
      var e = (s = this.shadowRoot) == null ? void 0 : s.querySelectorAll('[role="option"]'),
        t = (o = this.shadowRoot) == null ? void 0 : o.querySelector(".slds-has-focus");
      return Array.from(e).indexOf(t);
    }
  }, {
    key: "getListItemNodes",
    value: function getListItemNodes() {
      var e;
      return (e = this.shadowRoot) == null ? void 0 : e.querySelectorAll('[role="option"]');
    }
  }, {
    key: "scrollIntoView",
    value: function scrollIntoView() {
      var t;
      var e = (t = this.shadowRoot) == null ? void 0 : t.querySelector(".slds-has-focus");
      e == null || e.scrollIntoView({
        block: "nearest"
      });
    }
  }, {
    key: "handleArrowDown",
    value: function handleArrowDown() {
      this.open || (this.open = !0);
      var e = this.getActiveIndexOfListItems();
      e === -1 && this.setFocusClassForListItemAtIndex(0);
      var t = e + 1;
      t > this.getListItemNodes().length - 1 && (t = 0), this.setFocusClassForListItemAtIndex(t), this.removeFocusClassForListItemAtIndex(e), this.scrollIntoView();
    }
  }, {
    key: "handleArrowUp",
    value: function handleArrowUp() {
      this.open || (this.open = !0);
      var e = this.getActiveIndexOfListItems(),
        t = e - 1;
      t < 0 && (t = this.getListItemNodes().length - 1), this.setFocusClassForListItemAtIndex(t), this.removeFocusClassForListItemAtIndex(e), this.scrollIntoView();
    }
  }]);
}(p);
r([l()], i.prototype, "options");
r([l()], i.prototype, "value");
r([l()], i.prototype, "label");
r([l()], i.prototype, "placeholder");
r([l({
  type: Boolean
})], i.prototype, "open");
r([l({
  type: Boolean
})], i.prototype, "required");
r([l({
  type: Boolean
})], i.prototype, "valid");
r([l({
  attribute: "required-error-text"
})], i.prototype, "requiredErrorText");
r([h()], i.prototype, "displayedErrorText");
export { i as NjcCombobox };